<template>
  <div v-loading="loading" class="role-users-wrapper">
    <el-table :data="list" border size="mini" class="role-users-table">
      <el-table-column prop="name" label="姓名" min-width="160" />
      <el-table-column label="状态" min-width="100">
        <template slot-scope="{ row }">
          <span :style="{ color: Number(row.status) === 1 ? '' : '#F56C6C' }">
            {{ Number(row.status) === 1 ? '正常' : '过期' }}
          </span>
        </template>
      </el-table-column>
      <template slot="empty">该角色下暂无账号</template>
    </el-table>
  </div>
</template>

<script>
import RolesResource from '@/api/roles';

const rolesResource = new RolesResource();

export default {
  name: 'RoleUsers',
  props: {
    /** 角色 ID */
    roleId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      list: [],
    };
  },
  created() {
    this.getUsers();
  },
  methods: {
    /** 获取角色下的账号 - 列表接口已不再返回，展开二级列表时按角色 ID 单独请求 */
    async getUsers() {
      this.loading = true;
      try {
        const { list = [] } = await rolesResource.getRoleUsersApi(this.roleId);
        this.list = Array.isArray(list) ? list : [];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.role-users-wrapper {
  padding: 5px 10px;
}
</style>
